var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { API_GET_DM_HISTORY, API_GET_DM_PREVIEW } from ".";
import { parseMessage } from "./utils/dm.utils";
// public
export const getDMPreview = (address, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_DM_PREVIEW, {
            params: { address },
        });
        const messages = response.data;
        return messages.map((msg) => parseMessage(msg));
    }
    catch (err) {
        return [];
    }
});
export const getDMHistory = (fromAddress, toAddress, api) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield api.get(API_GET_DM_HISTORY, {
            params: { from_address: fromAddress, to_address: toAddress },
        });
        const messages = response.data;
        return messages.map((msg) => parseMessage(msg));
    }
    catch (err) {
        return [];
    }
});
//# sourceMappingURL=dm.js.map